import { Trans, useLingui } from '@lingui/react/macro';

import IconStoreRepair from '@/icons/StoreRepair.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import { useArticleName } from '@/models/article';
import type { TNotificationOfType } from '@/models/notification';

export const ArticleRepairStartedNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'article_repair_started'>;
}) => {
  const { t } = useLingui();

  const articleName = useArticleName({ article: notification.article });
  const workshopName = notification.data.workshop.name;

  return (
    <BaseNotification
      notificationLabel={t({
        id: 'notification.article-repair-started.label',
        message: `The workshop ${workshopName} will now start repairing the item ${articleName}`,
      })}
      icon={<IconStoreRepair />}
      type="neutral"
      notification={notification}
      notificationHeader={() => (
        <Trans id="notification.article-repair-started">Repair started by the workshop</Trans>
      )}
    />
  );
};
